import { useLogisticOfferList } from './useLogisticOfferList'

export const useLogisticOfferListSymbol = 'useLogisicOfferList'

export function provideComposables() {
  return {
    [useLogisticOfferListSymbol]: useLogisticOfferList,
  }
}
